import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { expenseEndpoints } from '@/lib/api/endpoints';
import { expenseKeys } from '@/lib/queryKeys';
import type { ExpenseListResponse } from '@/types/settings';

interface UseExpensesParams {
  status?: string;
  expenseType?: string;
  appointmentId?: string;
  page?: number;
  limit?: number;
  sortBy?: string;
  sortDir?: 'asc' | 'desc';
}

export function useExpenses(jobId: string | undefined, params: UseExpensesParams = {}) {
  return useApiQuery<ExpenseListResponse>({
    queryKey: expenseKeys.byJob(jobId ?? '', params),
    queryFn: () =>
      apiGet<ExpenseListResponse>(operationsClient, expenseEndpoints.listByJob(jobId as string), {
        params: {
          ...(params.status ? { status: params.status } : {}),
          ...(params.expenseType ? { expenseType: params.expenseType } : {}),
          ...(params.appointmentId ? { appointmentId: params.appointmentId } : {}),
          ...(params.page ? { page: params.page } : {}),
          ...(params.limit ? { limit: params.limit } : {}),
          ...(params.sortBy ? { sortBy: params.sortBy } : {}),
          ...(params.sortDir ? { sortDir: params.sortDir } : {}),
        },
      }),
    enabled: Boolean(jobId),
    showErrorToast: false,
  });
}
